import { Apple, Play, ExternalLink } from "lucide-react";
import { APP_STORE_URL, PLAY_STORE_URL, WEB_LOGIN_URL } from "@/lib/constants";
import appImg from "@/assets/finanzmanager-mockup.webp";
import appImg400 from "@/assets/finanzmanager-mockup-400.webp";
import appImg800 from "@/assets/finanzmanager-mockup-800.webp";

export default function AppSection() {
  return (
    <section className="py-20 md:py-28 bg-gradient-hero text-white relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-radial pointer-events-none" />
      <div className="container relative grid lg:grid-cols-2 gap-12 items-center">
        <div className="reveal order-2 lg:order-1 relative">
          <div className="absolute -inset-6 bg-accent/20 blur-3xl rounded-full" />
          <img
            src={appImg}
            srcSet={`${appImg400} 400w, ${appImg800} 800w, ${appImg} 928w`}
            sizes="(min-width: 1024px) 448px, 90vw"
            alt="FINABLE Finanzmanager App auf dem Smartphone"
            width={928}
            height={1152}
            loading="lazy"
            decoding="async"
            className="relative rounded-2xl shadow-elegant border border-white/10 w-full max-w-md mx-auto"
          />
        </div>

        <div className="reveal order-1 lg:order-2">
          <span className="text-accent font-semibold uppercase tracking-wider text-sm">Deine FINABLE-App</span>
          <h2 className="mt-3 font-display text-3xl md:text-4xl lg:text-5xl font-bold text-balance">
            Alle Finanzen immer und überall im Blick
          </h2>
          <p className="mt-6 text-lg text-white/80 leading-relaxed">
            Stell Dir vor, Du hättest alle Deine Versicherungen und Finanzen immer und überall im Blick – übersichtlich, digital und ganz einfach. Genau das bietet Dir unsere App „Finanzmanager"!
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            <a
              href={APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-5 py-3 rounded-xl bg-white text-primary font-semibold shadow-elegant hover:-translate-y-0.5 transition-all"
            >
              <Apple className="w-6 h-6" />
              <div className="text-left leading-tight">
                <div className="text-[10px] uppercase tracking-wider opacity-70">Laden im</div>
                <div className="text-sm">App Store</div>
              </div>
            </a>
            <a
              href={PLAY_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 px-5 py-3 rounded-xl bg-white text-primary font-semibold shadow-elegant hover:-translate-y-0.5 transition-all"
            >
              <Play className="w-6 h-6" />
              <div className="text-left leading-tight">
                <div className="text-[10px] uppercase tracking-wider opacity-70">Laden im</div>
                <div className="text-sm">Play Store</div>
              </div>
            </a>
          </div>

          <a
            href={WEB_LOGIN_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-6 inline-flex items-center gap-2 text-accent font-semibold hover:underline"
          >
            Im Browser einloggen <ExternalLink className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
}
